/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { WindowType       } from './window';
import { DocumentMetadata } from './document.metadata';

/**
 *
 * @class WorkBloxEditorMetadata
 *
 * @brief meta data for work blocks browser editor; edits just the scheduled outages info
 * for a scenario.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class WorkBloxEditorMetadata extends DocumentMetadata {

  /** the blob manager key if it's a blob */
  public key:  string = '/';

  /** the full content if we have it */
  public text: string = '';

  /** standard constructor */
  constructor(
    id:       string = '',
    title:    string = '',
    key:      string = '',
    text:     string = '',
    icon:     string = '<i class="fas fa-snowplow"></i>',
    type: WindowType = WindowType.WorkBloxEditor,
  ) {

    super(id, title, icon, type);

    this.key  = key;
    this.text = text;
  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({key: this.key});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any) {

    super.fromNode(node);

    this.key  = node.key;
  }
}
